/**
 * @module app.prospection.store.storeCtrl
 */
let moment = require('moment');

function StoreCtrl(
    $scope,
    $rootScope,
    $log,
    $q,
    fournisseurService,
    activitiesService,
    storeService,
    glpiService,
    store,
    userService,
    walletService,
    Notification,
    clientService
) {
    // $scope.selectActiveMenu(2);
    var self = this;

    if (!store) {
        self.error = 'impossible de trouver le magasin.';
    }
    self.loadingStore = true;
    self.isCommentSaving = false;
    self.isHoursSaving = false;
    self.store = store;
    self.services =
        store.services &&
        store.services.reduce(function(prev, curr) {
            prev[curr.service_id] = curr;
            return prev;
        }, {});

    self.isIDH = function() {
        if (self.services && !self.services.HOT) {
            return false;
        }
        return self.services.HOT.service_etat !== 'active';
    };
    self.selectedTab = 2;
    self.selectedSubTab = 1;



    if (store.customers) {
        self.age = (function() {
            var birthday = +new Date(store.customers[0].date_naissance_client);
            return ~~((Date.now() - birthday) / 31557600000);
        })();

        self.hasAge = store.customers[0].date_naissance_client && self.age < 100;
    }

    if(!self.store.contact.telephones_portable.length){
        self.store.contact.telephones_portable.push(null)
    }

    if(!self.store.contact.telephones_fixe.length){
        self.store.contact.telephones_fixe.push(null)
    }

    if (!self.store.orders) {
        self.store.orders = [];
    }

    if(self.store.infos_du_predecesseur.length > 0){
        self.store.infos_du_predecesseur[0].date_reelle_reprise = moment(self.store.infos_du_predecesseur[0].date_reelle_reprise).format('DD/MM/YYYY');
    }

    if(self.store.infos_du_successeur.length > 0){
        self.store.infos_du_successeur[0].date_reelle_reprise = moment(self.store.infos_du_successeur[0].date_reelle_reprise).format('DD/MM/YYYY');
    }

    self.possm = $rootScope.mode === 'prod'
        ? 'https://is.bimedia-it.com/customers-repository-new/BO/'+self.store.identifiant_magasin
        : 'https://is-preprod.bimedia-it.com/customers-repository-new/BO/'+self.store.identifiant_magasin;

    self.oldStore = JSON.parse(JSON.stringify(self.store));   // A revoir

    self.etatMag = {
        EATC:	'En attente de traitement de commande',
        EARP:	'En attente de reprise',
        EAIN:	'En attente d\'installation',
        INST:	'Installé',
        RESI:	'Résilié',
        ANPR:	'Ancien propriétaire'
    }

    self.leaser = {
        LEA000001: 'REALEASE CAPITAL',
        LEA000002: 'BNP PARIBAS LEASE GROUP',
        LEA000003: 'LEASECOM',
        LEA000004: 'GRENKELOCATION SAS',
        LEA000005: 'EASYFI',
        LEA000006: 'CORHOFI',
        LEA000007: 'NATIOCREDIMURS',
        LEA000008: 'CM CIC BAIL',
        LEA000009: 'LCL',
        LEA000010: 'NATIXIS LEASE',
        LEA000011: 'CMC CIC BAIL (RFC)',
        LEA000012: 'LEASER EN ATTENTE',
        LEA000015: 'LEASER AUTOPORTE',
        LEA000017: 'NAP SERVICES',
        LEA000018: 'LEASCORP',
        LEA000019: 'CM CIC LEASING SOLUTIONS',
        LEA000020: 'BANQUE POPULAIRE RIVE DE PARIS',
    }

    /* ACTIVITIES */
    self.activities = activitiesService.list();
    self.deleteActivities = [];

    self.currentActivities = (self.store.activities || []).reduce(function(prev, curr) {
        prev[curr.id] = true;
        return prev;
    }, {});

    self.toggleActivity = function(activity) {
        if (self.currentActivities[activity]) {
            delete self.currentActivities[activity];
            self.deleteActivities.push(activity);
        } else {
            self.currentActivities[activity] = true;
            if (self.deleteActivities.indexOf(activity) !== -1) {
                let index = self.deleteActivities.indexOf(activity);
                self.deleteActivities.splice(index);
            }
        }
    };

    /*  QUALIFICATIONS */
    self.fournisseurs = fournisseurService.list();
    self.motifs = fournisseurService.motifs();
    self.fieldsToWatchModifications = {};

    self.store.qualification.nb_passages = self.store.qualification.nb_passages.split('-').join('/');
    if (self.store.etat_magasin === 3 || self.isTeleproForm) {
        self.store.qualification = self.store.qualification || {
            nb_passages: null,
            fournisseur: 'Strator',
            fournisseur_id: 1,
            type_contrat: 'Location',
            type_contrat_id: 'LOC',
            fin_contrat: null,
            nb_caisses: 1,
            saisonnier: false,
            mois_ouverture: {
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false,
                7: false,
                8: false,
                9: false,
                10: false,
                11: false,
                12: false
            },
            categorie_ca: {
                tabac: 4,
                demat: 0,
                moyen_paiement: 0,
                produit_physique: null,
                webtostore: null
            }
        };

    }
    if (self.store.qualification.fin_contrat) {
        self.store.qualification.fin_contrat = new Date(moment(self.store.qualification.fin_contrat).format('YYYY-MM-DD'));
        self.store.qualification.fin_contrat = moment(self.store.qualification.fin_contrat).get('year') === 1599 ? null : self.store.qualification.fin_contrat;
    }
    if (self.store.qualification.date_signature){
        self.store.qualification.date_signature = new Date(moment(self.store.qualification.date_signature).format('YYYY-MM-DD'));
    }

    self.isValidDateFinContrat = () => {
        return !moment(self.store.qualification.fin_contrat).isBefore(moment([2000, 0, 1]));

    }

    self.controlQualification = function(){
        if(self.store.qualification.signe_concurrence === 1){
            self.store.qualification = angular.copy(self.oldStore.qualification);
            self.store.qualification.date_signature = self.store.qualification.date_signature
                ? new Date(moment(self.store.qualification.date_signature).format('YYYY-MM-DD'))
                : null;
            self.store.qualification.fin_contrat = self.store.qualification.fin_contrat
                ? new Date(moment(self.store.qualification.fin_contrat).format('YYYY-MM-DD'))
                : null;
        }
    }

    /**
     * Set the fields to watch
     * @param {Array} fields : [
     *   {field : string, value: *, label : string, type : string}
     * ]
     * field : field to watch modifications
     * label : label to display in the email
     * value : the current value of the watched field
     * type  : the type of the field. Only the type date is defined.
     */
    function _setFieldsToWatch(fields) {
        var fieldsLength = fields.length;
        var type, value;
        for (var i = 0; i < fieldsLength; i++) {
            type = fields[i].type ? fields[i].type : null;
            value =
                type && type === 'date' && fields[i].value
                    ? moment(fields[i].value).format('DD/MM/YYYY')
                    : fields[i].value;

            self.fieldsToWatchModifications[fields[i].field] = {
                label: fields[i].label,
                new: null,
                old: value
            };
        }
    }

    /**
     * Update a field to watch modifications
     * @param  {String} field
     * @param  {*} newValue
     * @param  {String} type
     */
    function _updateFieldToWatch(field, newValue, type) {
        var value = newValue;
        var field = self.fieldsToWatchModifications[field];

        if (value) {
            if (type && type === 'date') {
                value = moment(value).format('DD/MM/YYYY');
            }
        }

        if (value !== field.old) {
            field.new = value;
        }
    }

    _setFieldsToWatch([
        {
            field: 'dateEndContract',
            value: store.qualification.fin_contrat,
            label: 'Date de fin de contrat',
            type: 'date'
        }
    ]);

    /* ORDERS */

    self.ordersFilter = function(order) {
        return order.articles.some(function(article) {
            if (article !== null) {
                return self.tillsFilter(article) || self.accessoriesFilter(article);
            }
        });
    };

    self.tillsFilter = function(article) {
        if (article !== null) {
            return article.categorie_materiel === 'CAISSE' || article.categorie_materiel === 'CAI';
        }
    };

    self.accessoriesFilter = function(article) {
        if (article !== null) {
            return article.categorie_materiel === 'ACCESSOIRES AVEC DFC' || article['article'] === 'NEGOS000011' || article.categorie_materiel === 'BCO';
        }
    };

    self.store.orders.forEach(function(order) {
        var contracts = (self.store.contracts || []).filter(function(contract) {
            return contract.no_affaire == order.numero_affaire;
        });

        if (contracts.length) {
            order.date_signature = contracts[0].date_signature;
            order.date_debut_validite = contracts[0].date_debut_validite;
            order.date_fin_validite = contracts[0].date_fin_validite;
        }
        else {
            order.date_signature = null;
            order.date_debut_validite = null;
            order.date_fin_validite = null;
        }
    });

    /*  CONTRACTS */
    self.contracts = getGroupedContracts();

    // Group contracts with the same id
    function getGroupedContracts() {
        var contractsById = [];
        var contractsIds = (self.store.contracts || [])
            .map(function(contract) {
                return contract.identifiant_contrat;
            })
            .filter(function(value, index, self) {
                return self.indexOf(value) === index;
            });
        contractsIds.forEach(function(id) {
            var groupedContracts = self.store.contracts.filter(function(contractToFilter) {
                return contractToFilter.identifiant_contrat === id;
            });
            if (groupedContracts) {
                groupedContracts.map(contract => {
                    if(contract.type_contrat === 'MAI'){
                        groupedContracts.etat = contract.cloture ? 'Clôturé' : contract.resilie ? 'Résilié' : '';
                    }
                })
                contractsById.push(groupedContracts);
            }
        });
        return contractsById;
    }

    // Get monthly price for a contract mensualite : find matching materiel and deduce "generosite"
    self.getMensualite = function(materiels, mensualite) {
        var matchingMateriel = materiels.find(function(materiel) {
            if (materiel === null) {
                return false;
            }
            return (
                materiel.article === mensualite.id_type_mensualite &&
                materiel.identifiant === mensualite.identifiant_mensualite
            );
        });
        // mensualite.montant * (1 - generosite_pourcent |0 ) - (generosite_montant | 0)
        var generosite_montant = parseFloat(matchingMateriel && matchingMateriel.generosite_montant) | 0;
        var generosite_pourcent = parseFloat(matchingMateriel && matchingMateriel.generosite_poucent) | 0;
        return Number(parseFloat(mensualite.montant) * (1 - generosite_pourcent / 100) - generosite_montant).toFixed(2);
    };

    function isActiveDate(field) {
        return function(c) {
            if (!c[field]) {
                return false; // end not defined
            }
            var m = moment(c[field]);
            return m.isValid() && m.isAfter(new Date());
        };
    }

    // self.isContractActive = isActiveDate('date_fin_validite');

    // self.isContractProspectActive = isActiveDate('fin_contrat');

    self.isOpeningHoursFormDisabled = false;
    self.errorOpeningHours = null;
    self.isOpeningHoursSent = false;
    self.openingHoursText = 'Les horaires ont été modifiés';

    /**
     * Build opening hours form data
     * Due to ngModel combined with input type time, the model has to be a date
     * @param {Array} data : [[firstHour, secondHour], [...]]
     * @param {String} delimeter : ':' or 'h'
     * @param {String} replacement : ':' or 'h'
     */
    function _buildHours(data, delimeter, replacement) {
        var dayPart, date;
        var res = [];
        var regex = new RegExp(delimeter);
        for (var j = 0; j < 2; j++) {
            if (!data[j]) {
                date = new Date(1970, 0, 1, 0, 0);
                dayPart = [null, null];
            }
            else {
                dayPart = data[j].slice(0);
                dayPart[0] = dayPart[0].replace(regex, replacement);
                date = moment()
                    .hours(dayPart[0].split(':')[0])
                    .minutes(dayPart[0].split(':')[1])
                    .seconds(0)
                    .toArray();
                dayPart[0] = new Date(date[0], date[1], date[2], date[3], date[4]);
                dayPart[1] = dayPart[1].replace(regex, replacement);
                date = moment()
                    .hours(dayPart[1].split(':')[0])
                    .minutes(dayPart[1].split(':')[1])
                    .seconds(0)
                    .toArray();
                dayPart[1] = new Date(date[0], date[1], date[2], date[3], date[4]);
            }

            res.push(dayPart);
        }
        return res;
    }

    self.openingHoursForm = {
        horaires_ouverture_lundi: _buildHours(self.store.horaires_ouverture.lundi, 'h', ':'),
        horaires_ouverture_mardi: _buildHours(self.store.horaires_ouverture.mardi, 'h', ':'),
        horaires_ouverture_mercredi: _buildHours(self.store.horaires_ouverture.mercredi, 'h', ':'),
        horaires_ouverture_jeudi: _buildHours(self.store.horaires_ouverture.jeudi, 'h', ':'),
        horaires_ouverture_vendredi: _buildHours(self.store.horaires_ouverture.vendredi, 'h', ':'),
        horaires_ouverture_samedi: _buildHours(self.store.horaires_ouverture.samedi, 'h', ':'),
        horaires_ouverture_dimanche: _buildHours(self.store.horaires_ouverture.dimanche, 'h', ':')
    };

    /**
     * Recopy the monday hours into the other days
     */
    self.recopyMondayHours = function() {
        var monday = self.openingHoursForm.horaires_ouverture_lundi;
        var keys = Object.keys(self.openingHoursForm);
        keys = keys.slice(1);
        for (var i = 0; i < keys.length; i++) {
            self.openingHoursForm[keys[i]] = [];

            if (monday[0]) {
                self.openingHoursForm[keys[i]].push(monday[0].slice(0));

                if (monday[1]) {
                    self.openingHoursForm[keys[i]].push(monday[1].slice(0));
                }
            }
        }
    };

    /**
     * Update the store opening hours
     */
    self.updateHours = function() {
        self.isOpeningHoursFormDisabled = true;
        self.errorOpeningHours = null;
        self.isHoursSaving = true;
        // Update store opening hours
        var keys = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
        for (var i = 0; i < keys.length; i++) {
            for (var j = 0; j < 2; j++) {
                // The open and close hours are defined
                if (
                    self.openingHoursForm['horaires_ouverture_' + keys[i]][j][0] &&
                    self.openingHoursForm['horaires_ouverture_' + keys[i]][j][1]
                ) {
                    if (
                        self.openingHoursForm['horaires_ouverture_' + keys[i]][j][0] >=
                        self.openingHoursForm['horaires_ouverture_' + keys[i]][j][1]
                    ) {
                        self.isOpeningHoursFormDisabled = false;
                        return (self.errorOpeningHours =
                            "L'heure d'ouverture ne peut être supérieure ou égale à la date de fermeture");
                    }

                    self.store.horaires_ouverture[keys[i]][j] = [];
                    if (self.openingHoursForm['horaires_ouverture_' + keys[i]][j][0]) {
                        self.store.horaires_ouverture[keys[i]][j][0] = moment(
                            self.openingHoursForm['horaires_ouverture_' + keys[i]][j][0]
                        )
                            .format('HH:mm')
                            .replace(/:/, 'h');
                    }

                    if (self.openingHoursForm['horaires_ouverture_' + keys[i]][j][1]) {
                        self.store.horaires_ouverture[keys[i]][j][1] = moment(
                            self.openingHoursForm['horaires_ouverture_' + keys[i]][j][1]
                        )
                            .format('HH:mm')
                            .replace(/:/, 'h');
                    }
                }
                else {
                    if (
                        self.openingHoursForm['horaires_ouverture_' + keys[i]][j][0] &&
                        !self.openingHoursForm['horaires_ouverture_' + keys[i]][j][1]
                    ) {
                        self.isOpeningHoursFormDisabled = false;
                        return (self.errorOpeningHours = "L'heure de fermeture doit être définie");
                    }
                    if (
                        !self.openingHoursForm['horaires_ouverture_' + keys[i]][j][0] &&
                        self.openingHoursForm['horaires_ouverture_' + keys[i]][j][1]
                    ) {
                        self.isOpeningHoursFormDisabled = false;
                        return (self.errorOpeningHours = "L'heure d'ouverture doit être définie");
                    }

                    if (j === 0) {
                        self.store.horaires_ouverture[keys[i]] = [];
                    }
                    else {
                        self.store.horaires_ouverture[keys[i]] = self.store.horaires_ouverture[keys[i]].slice(0, 1);
                    }
                }
            }
        }

        // Send the updated hours to the RFC
        return  storeService.updateHours(self.store).then(function(res) {
            self.isOpeningHoursFormDisabled = false;

            //self.isOpeningHoursSent = true;
            // setTimeout(function() {
            //     self.isOpeningHoursSent = false;
            // }, 100);
            self.isHoursSaving = false;
        });
    };

    self.updateStoreComment = function() {
        return storeService
            .updateStoreComment({comment: self.store.commentaire_general || ' ', enseigne:self.store.enseigne || ' '}, self.store.identifiant_magasin);
    };

    self.updateStoreContact = function() {
        if (self.isTeleproForm){
            return storeService
                .updateStoreContact(self.store.contact, self.store.identifiant_magasin);
        }
        return $q.when('ok');
    };

    self.updateStoreCustomer = function() {
        if (self.isTeleproForm) {
            self.store.customers[0].sexe_client = self.store.customers[0].sexe_client !== 0 ? self.store.customers[0].sexe_client : 4;
            return storeService
                .updateStoreCustomer(self.store.customers[0], self.store.identifiant_magasin)
                .then(() => {
                    self.store.client[0].firstName = self.store.customers[0].prenom_client;
                    self.store.client[0].lastName = self.store.customers[0].nom_client;
                    clientService.createUpdate(self.store.client[0])
                });
        }
        return $q.when('ok');
    };

    self.updateStoreQualification = function() {
        //self.isSaving = true;
        self.store.activities = Object.keys(self.currentActivities).map(function(key) {
            return {
                id: key,
                nom: key
            };
        });

        self.store.deleteActivities = self.deleteActivities;

        _updateFieldToWatch('dateEndContract', self.store.qualification.fin_contrat, 'date');
        self.store.fieldsToWatch = self.fieldsToWatchModifications;
        if(!self.isValidDateFinContrat()){
            return Promise.reject({data : {description : 'La date de fin de contrat ne peut pas être avant le 1 janvier 2000.'}});
        }
        return storeService
            .update(self.store)
            .then(function () {
                if (Object.keys(self.store.fieldsToWatch).length) {
                    let isFieldToWatchModified;
                    Object.keys(store.fieldsToWatch).forEach(field => {
                        isFieldToWatchModified =
                            self.store.fieldsToWatch[field].old !== self.store.fieldsToWatch[field].new &&
                            self.store.fieldsToWatch[field].new !== null;
                    });
                    if (isFieldToWatchModified && !self.isTeleproForm){
                        return storeService.sendQualificationUpdate(self.store);
                    }
                }
            })
            .then(function(){
                let business = self.store.wallet.filter(bus => bus.businessStatusId === 1 || bus.businessStatusId === 2 );
                if (business[0] && moment(business[0].dateFinContrat) !== moment(self.store.qualification.fin_contrat) && self.store.qualification.signe_concurrence === 1){
                    business[0].dateFinContrat = moment(self.store.qualification.fin_contrat).format('YYYY-MM-DD');
                    for(let i = 0; i < self.store.wallet.length; i++){
                        if(self.store.wallet[i].businessId === business[0].businessId){
                            self.store.wallet[i].dateFinContrat = business[0].dateFinContrat;
                        }
                    }

                    console.log('Affaire ' + business[0].businessId + ' mise à jour.')
                    return walletService.updateBusiness(business[0]);
                }
            });
    };

    self.sendStoreUpdateRequest = function() {
        storeService.sendStoreUpdateRequest(self.store, self.oldStore);
    };

    self.changeTel = (phoneType) => {
        let att = 'telephone_' + phoneType;
        let att2 = 'telephones_' + phoneType;
        self.store.contact[att] = self.store.contact[att2][0];
    }

    self.save = function(){
        self.loadingStore = true;
        self.updateStoreCustomer().then(function() {
            self.updateStoreContact().then(function () {
                self.updateStoreComment().then(function () {
                    self.updateHours().then(function () {
                        self.updateStoreQualification().then(function () {
                            Notification.success('Client mis à jour');
                        }).catch(function (err) {
                            Notification.error(err.data)
                        }).finally(function () {
                            self.loadingStore = false;
                        });
                    });
                });
            });
        });
    }

    /* Format Date time received as YYYY-MM-DD HH:MM:SS to remove the time part*/
    self.formatDateTime = function(date) {
        return date !== null ? date.split(' ')[0] : '';
    };

    self.isEditable = function(){
        if(self.isExt && !$rootScope.user.rights.userDevance){
            return true;
        }
        // if(self.isTeleproForm){
            if(self.store.etat_magasin !== 4 ){
                return false;
            }
            // return true;
        // }
        if(self.store.etat_magasin === 3 ){
            return false;
        }
        return true;
    }

    function _mapServices(allServices, storeService){
        let services = [];

        for (const serv of allServices){
            if(storeService[serv.id]){
                services.push(storeService[serv.id])
            }else{
                let service = {
                    service_id: serv.id,
                    service_nom: serv.nom,
                    service_etat: 'inactive'
                }
                services.push(service)
            }
        }
        return services;
    }

    function _init() {
        self.loadingStore = true;
        self.userNetwork = $rootScope.userNetwork;
        self.isExt = userService.isExternalUser(self.userNetwork.user) && $rootScope.user.rights.userDevance ? false : userService.isExternalUser(self.userNetwork.user);
        self.user = $rootScope.user;
        self.isTeleproForm = userService.isTeleproForm($rootScope.user)
        storeService.getAllServices()
            .then(services => {
                self.allServices = services;
                self.store.services = _mapServices(self.allServices, self.services);
            });
    }

    _init();
    $log.info('Store', store);
    return self;
}

StoreCtrl.$inject = [
    '$scope',
    '$rootScope',
    '$log',
    '$q',
    'fournisseurService',
    'activitiesService',
    'storeService',
    'glpiService',
    'store',
    'userService',
    'walletService',
    'Notification',
    'clientService'
];

angular
    .module('app.prospection.store.storeCtrl', ['ui.bootstrap', 'ui-notification'])
    .controller('StoreCtrl', StoreCtrl);
